/**
 * Show Full Itinerary Button Component
 * Expands/collapses the full itinerary display
 * Only renders if there are hidden days
 */

import React from "react";
import { ColletteButton } from "@collette-travel/collette-common-controls";
import type { ShowFullItineraryButtonProps } from "../types";

const ShowFullItineraryButton: React.FC<ShowFullItineraryButtonProps> = ({
  isExpanded,
  onClick,
  testIdPrefix
}) => 
  // WHY: Parent component handles conditional rendering based on totalDays > initialDaysToShow
  // This button just toggles between "Show Full Itinerary" and "Collapse Itinerary" based on isExpanded
   (
    <ColletteButton
      variant="outlined"
      size="large"
      label={isExpanded ? "Collapse Itinerary" : "Show Full Itinerary"}
      testId={`${testIdPrefix}_show-full-itinerary-button`}
      onClick={onClick}
    />
  )
;

export default ShowFullItineraryButton;
